import { createSystem, defaultBaseConfig, defaultConfig, defineConfig, mergeConfigs } from '@chakra-ui/react';

import { breakpoints, keyframes, layerStyles, recipes, semanticTokens, slotRecipes, tokens } from './theme';

const CHAKRA_BLOCKWORKS_SYSTEM_CLASSNAME = 'ck-bw-root';

const blockworksConfig = mergeConfigs(
    defaultBaseConfig,
    defineConfig({
        strictTokens: false,
        preflight: {
            level: 'element',
            scope: '[class*="chakra-"]',
        },
        globalCss: defaultConfig.globalCss,
        cssVarsRoot: `:where(:root, :host, .${CHAKRA_BLOCKWORKS_SYSTEM_CLASSNAME})`,
        theme: {
            ...defaultConfig.theme,
            keyframes,
            slotRecipes,
            recipes,
            layerStyles,
            tokens,
            semanticTokens,
            breakpoints,
        },
    }),
);

const blockworksSystem = createSystem(blockworksConfig);

export { blockworksSystem, blockworksConfig, CHAKRA_BLOCKWORKS_SYSTEM_CLASSNAME };
/** export default for chakra-cli type generation */
export default blockworksSystem;
